import { useAuth } from "@/context/AuthContext";
import { LayoutGrid, School, LineChart, Megaphone, PenTool, Users, Scale, ExternalLink } from "lucide-react";

// Teammates who get the cross-app switcher bar.
const ALLOWED_EMAILS = new Set([
  "joey@indielaw.com",
  "anu@indielaw.com",
  "kat@indielaw.com",
  "katie@indielaw.com",
  "jenna@indielaw.com",
  "jaime@indielaw.com",
  "reyna@indielaw.com",
  "gerald@indielaw.com",
  "rica@indielaw.com",
  "bianca@indielaw.com",
  "almira@indielaw.com",
]);

// The Indie Law app family. `current: true` marks this app (not a link).
const SITES = [
  { id: "indie-university", label: "Indie University", icon: School, url: "/", current: true },
  { id: "financial-command-center", label: "Financial Command Center", icon: LineChart, url: "https://indieforecast.com" },
  { id: "marketing-intel", label: "Marketing Intel", icon: Megaphone, url: "https://indiemarketingintel.com" },
  { id: "content-engine", label: "Content Engine", icon: PenTool, url: "https://indielawcontent.com" },
  { id: "client-portal", label: "Client Portal", icon: Users, url: "https://indielawclients.com" },
  { id: "legallylegit-ai", label: "LegallyLegit.ai", icon: Scale, url: "https://legallylegit.ai" },
];

export default function AppSwitcher() {
  const { user } = useAuth();
  if (!user || !ALLOWED_EMAILS.has((user.email || "").toLowerCase())) return null;

  return (
    <div data-testid="app-switcher-bar"
      className="sticky top-0 z-30 border-b border-[#141B4D]/10 bg-[#F2E9DB]/85 backdrop-blur-md">
      <div className="flex items-center gap-2 px-6 py-2 overflow-x-auto no-scrollbar">
        <span className="flex items-center gap-1.5 shrink-0 pr-2 mr-1 border-r border-[#141B4D]/10 text-[10px] font-bold uppercase tracking-widest text-[#141B4D]/40">
          <LayoutGrid className="w-3.5 h-3.5" /> Indie Law
        </span>
        {SITES.map((s) =>
          s.current ? (
            <span key={s.id} data-testid={`app-switcher-current-${s.id}`}
              className="flex items-center gap-2 shrink-0 px-3 py-1.5 rounded-full text-xs font-bold bg-[#141B4D] text-[#FFD100]">
              <s.icon className="w-4 h-4" /> {s.label}
            </span>
          ) : (
            <a key={s.id} href={s.url} target="_blank" rel="noreferrer"
              data-testid={`app-switcher-link-${s.id}`}
              className="group flex items-center gap-2 shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold text-[#141B4D]/70 hover:text-[#141B4D] hover:bg-white transition-colors">
              <s.icon className="w-4 h-4" /> {s.label}
              <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-60 transition-opacity" />
            </a>
          )
        )}
      </div>
    </div>
  );
}
